<template>
        <div class="community-write-info app">
          <CommunityPolicy/>
        </div>
</template>

<script>
import CommunityPolicy from '@/components/terms/CommunityPolicy.vue';

export default {
  components:{
    CommunityPolicy,
  },     
}
</script>

<style>

</style>